import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PrimaryButton from '../common/PrimaryButton';

function Alert(props) {
  const { isOpen, onClose, title, message } = props;
  const [open, setOpen] = useState(isOpen);

  const alertTitle = title ? title : 'Title';
  const alertMessage = message ? message : '';

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!open) {
      onClose();
    }
    return () => {
      setOpen(false);
    };
  }, [open]);

  return (
    <>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" className="modal-alert">
        <DialogTitle id="alert-dialog-title" className="modal-title">
          {alertTitle}
          <button className="btn-close" onClick={handleClose}>
            close
          </button>
        </DialogTitle>
        <DialogContent className="modal-contents">
          <DialogContentText id="alert-dialog-description">{alertMessage}</DialogContentText>
        </DialogContent>
        <DialogActions className="modal-buttons">
          <PrimaryButton type={'button'} text={'Ok'} btnClass={'btn-primary-accent'} onClick={handleClose} />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Alert;
